import SectionRoute from "@dashboard/auth/components/SectionRoute";
import { PermissionEnum } from "@dashboard/graphql";
import { type RouteProps } from "react-router-dom";

import AtticApiUsageSection from "./index";

/** Platform superusers only the same grant as the activity log. */
export const ATTIC_API_USAGE_PERMISSIONS = [PermissionEnum.VIEW_ACTIVITY_LOG];

/**
 * The section's route, gated on VIEW_ACTIVITY_LOG. It lives here rather than
 * inline in src/index.tsx so the gate can be tested: that file renders the
 * whole app when imported. Give it `path` where it is used, so the enclosing
 * <Switch> can match on it.
 */
export const AtticApiUsageRoute = (props: RouteProps) => (
  <SectionRoute
    {...props}
    permissions={ATTIC_API_USAGE_PERMISSIONS}
    component={AtticApiUsageSection}
  />
);
